export default __webpack_public_path__ + "static/media/close-dispute.65b6422d.svg";